"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchDataType = void 0;
var fetchDataType = function (params) {
    var _a;
    var setState = params.setState, fetchAction = params.fetchAction, mode = params.mode, controller = params.controller, controllers = params.controllers, onError = params.onError;
    if (mode === "paginated") {
        setState(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
    }
    if (mode === "value") {
        var id_1 = params.id;
        if (id_1) {
            setState(function (prevState) {
                var _a, _b;
                return __assign(__assign({}, prevState), { loading: true, byId: prevState.byId
                        ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id_1] = __assign(__assign({}, prevState.byId[id_1]), { loading: true }), _a)) : (_b = {}, _b[id_1] = { loading: true }, _b) });
            });
        }
        else {
            setState(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
        }
    }
    if (mode === "list") {
        setState(function (prevState) { return (__assign(__assign({}, prevState), { loading: true })); });
    }
    if (controller && controllers) {
        if (controllers[controller]) {
            (_a = controllers[controller]) === null || _a === void 0 ? void 0 : _a.abort();
        }
        controllers[controller] = new AbortController();
    }
    return fetchAction
        .then(function (response) {
        if (controllers && controller && controllers[controller]) {
            controllers[controller] = null;
        }
        if (mode === "paginated") {
            if (response.success) {
                setState(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, list: response, error: undefined })); });
            }
        }
        if (mode === "value") {
            if (response.success) {
                var id_2 = params.id;
                if (id_2) {
                    setState(function (prevState) {
                        var _a, _b;
                        return {
                            loading: false,
                            value: response.data,
                            error: undefined,
                            byId: prevState.byId
                                ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id_2] = {
                                    value: response.data,
                                    loading: false,
                                    error: undefined,
                                }, _a)) : (_b = {},
                                _b[id_2] = {
                                    value: response.data,
                                    loading: false,
                                    error: undefined,
                                },
                                _b),
                        };
                    });
                }
                else {
                    setState({
                        loading: false,
                        value: response.data,
                        error: undefined,
                    });
                }
            }
        }
        if (mode === "list") {
            if (response.success) {
                setState({
                    loading: false,
                    list: response.data,
                    error: undefined,
                });
            }
        }
        if (response.success === false) {
            if (onError) {
                onError(response);
            }
            if (mode === "value" && params.id) {
                var id_3 = params.id;
                setState(function (prevState) {
                    var _a, _b;
                    return __assign(__assign({}, prevState), { loading: false, error: response, byId: prevState.byId
                            ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id_3] = __assign(__assign({}, prevState.byId[id_3]), { loading: false, error: response }), _a)) : (_b = {},
                            _b[id_3] = {
                                loading: false,
                                error: response,
                            },
                            _b) });
                });
            }
            else {
                setState(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: response })); });
            }
        }
    })
        .catch(function (error) {
        if (error.name === "AbortError") {
            if (controllers && controller && controllers[controller]) {
                controllers[controller] = null;
            }
            return;
        }
        if (onError) {
            onError(error);
        }
        if (mode === "value" && params.id) {
            var id_4 = params.id;
            setState(function (prevState) {
                var _a, _b;
                return (__assign(__assign({}, prevState), { loading: false, error: error, byId: prevState.byId
                        ? __assign(__assign({}, prevState.byId), (_a = {}, _a[id_4] = __assign(__assign({}, prevState.byId[id_4]), { loading: false, error: error }), _a)) : (_b = {},
                        _b[id_4] = {
                            loading: false,
                            error: error,
                        },
                        _b) }));
            });
        }
        else {
            setState(function (prevState) { return (__assign(__assign({}, prevState), { loading: false, error: error })); });
        }
    });
};
exports.fetchDataType = fetchDataType;
